import {
  ComponentClass,
  DetailedHTMLProps,
  FocusEvent,
  FunctionComponent,
  HtmlHTMLAttributes,
  InputHTMLAttributes,
  NamedExoticComponent,
  ReactNode,
} from "react";
import { RefType } from "../../../types";

export enum InputContainerState {
  default = "default",
  error = "error",
  warning = "warning",
  success = "success",
  progress = "progress",
}

export type ExpectedInputProps = {
  placeholder?: unknown, // ???????
  id?: unknown,
  className?: unknown,
  disabled?: unknown,
  value?: unknown
  onChange?: (...v: any) => unknown
};

export type InputContainerSize = "sm" | "md"

export type InputContainerBaseProps<P extends ExpectedInputProps = InputHTMLAttributes<HTMLInputElement>, R extends unknown = HTMLInputElement> =
  {
    ref?: RefType<R>,
    inputComponent?: string | FunctionComponent<P> | ComponentClass<P, any> | NamedExoticComponent<P>,
    inputSize?: InputContainerSize,
    label?: ReactNode,
    hintText?: ReactNode,
    inputState?: InputContainerState,
    mapPropsToInput?: (props: { allProps: InputContainerProps<P, R>, inputProps: P }) => P,
    onClear?: (() => void) | null,
    additionalOnBlurCheck?: (e: FocusEvent<HTMLDivElement>) => boolean
    hideErrorIcon?: boolean,
    hideHintText?: boolean,
    isClearable?: boolean,
    renderClearButtonOnEmptyState?: boolean,
    inFocusedState?: boolean,
    withFocusWithin?: boolean,
    inputClassName?: string,
    rootContainerProps?: HtmlHTMLAttributes<HTMLDivElement>,
    labelProps?: HtmlHTMLAttributes<HTMLLabelElement>,
    containerProps?: DetailedHTMLProps<HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    inputContainerProps?: HtmlHTMLAttributes<HTMLDivElement>,
    clearButtonProps?: HtmlHTMLAttributes<HTMLButtonElement>,
    hintProps?: HtmlHTMLAttributes<HTMLSpanElement>,
    startContainerAdornment?: ReactNode,
    endContainerAdornment?: ReactNode,
    startAdornment?: ReactNode,
    endAdornment?: ReactNode,
    additionalInputContent?: ReactNode | ReactNode[],
  }

export type InputContainerProps<P extends ExpectedInputProps = InputHTMLAttributes<HTMLInputElement>, R extends unknown = HTMLInputElement> =
  InputContainerBaseProps<P, R> & P;

const InputContainerComponent = <P extends ExpectedInputProps = InputHTMLAttributes<HTMLInputElement>, R extends unknown = HTMLInputElement>(props: InputContainerProps<P, R>) => <></>;
export type InputContainerComponentType = typeof InputContainerComponent;
